import axiosInstance from "../config/axiosInterceptor";

export async function getLog(nodeId, options = {}) {
  const currentTimeInSeconds = Math.floor(Date.now() / 1000);
  const threeDaysAgoInSeconds = currentTimeInSeconds - 259200;

  const logFilterData = {
    start: options.start || threeDaysAgoInSeconds,
    end: options.end || currentTimeInSeconds,
    dTypeList: options.dTypeList || [],
    nodeList: options.nodeList || [nodeId],
    subjects: options.subjects || [],
    severities: options.severities || [],
    page: options.page || 1,
    pageSize: options.pageSize || 5000,
  };

  return await axiosInstance.post("/api/TopicData/GetLog", logFilterData);
}

export async function getLogSetFlag(getAndSetFlag0Data) {
  return await axiosInstance.post(
    "/api/TopicData/GetLogSetFlag",
    getAndSetFlag0Data,
  );
}

export async function getTopicData(nodeId, startTime = null, endTime = null) {
  const currentTimeInSeconds = endTime || Math.floor(Date.now() / 1000);
  const fiveDaysAgoInSeconds =
    startTime || Math.floor(Date.now() / 1000) - 5 * 24 * 60 * 60;

  const telemetryFilterData = {
    topic: "telemetry",
    start: fiveDaysAgoInSeconds,
    end: currentTimeInSeconds,
    nodeList: [nodeId],
    dTypeList: null,
    objectCodeList: null,
    objectCodeValueFilterStringList: null,
    count: 1500,
  };

  return await axiosInstance.post("/api/TopicData", telemetryFilterData);
}

export async function getTopicDataLV(nodeId, startTime = null, endTime = null) {
  const currentTimeInSeconds = endTime || Math.floor(Date.now() / 1000);
  const sixMonthsInSeconds = 15768000;
  const defaultStartTime = currentTimeInSeconds - sixMonthsInSeconds;
  let finalStartTime = startTime !== null ? startTime : defaultStartTime;

  finalStartTime =
    finalStartTime !== null && finalStartTime >= 0 ? finalStartTime : 0;

  const telemetryFilterData = {
    topic: "telemetry",
    start: finalStartTime,
    end: currentTimeInSeconds,
    nodeList: [nodeId],
    dTypeList: null,
    objectCodeList: null,
    objectCodeValueFilterStringList: null,
    count: 1,
  };

  return await axiosInstance.post("/api/TopicData", telemetryFilterData);
}

export async function getTopicDataWithAggregation(telemetryAggregationData) {
  return await axiosInstance.post(
    "/api/TopicData/GetTopicDataWithAggregation",
    telemetryAggregationData,
  );
}

export async function getEventDataWithAggregation(eventAggregationData) {
  return await axiosInstance.post(
    "/api/TopicData/GetEventDataWithAggregation",
    eventAggregationData,
  );
}

export async function getEventDataWithAggregationByNodeId(
  nodeId,
  eventAggregationData,
) {
  return await axiosInstance.post(
    `/api/TopicData/GetEventDataWithAggregationByNodeId/${nodeId}`,
    eventAggregationData,
  );
}

export async function getEventKeyValue(eventFilterData) {
  return await axiosInstance.post(
    "/api/TopicData/GetEventKeyValue",
    eventFilterData,
  );
}

export async function getEventKeyValueByNode(nodeId, eventFilterData) {
  return await axiosInstance.post(
    `/api/TopicData/GetEventKeyValueByNode/${nodeId}`,
    eventFilterData,
  );
}

export async function getTelemetriesByNode(telemetriesByNodeData) {
  return await axiosInstance.post(
    "/api/TopicData/GetTelemetriesByNode",
    telemetriesByNodeData,
  );
}

export async function getEventData(nodeList, options = {}) {
  const currentTimeInSeconds = Math.floor(Date.now() / 1000);
  const threeDaysAgoInSeconds = currentTimeInSeconds - 259200;

  const eventFilterData = {
    topic: options.topic || "event",
    start: options.start || threeDaysAgoInSeconds,
    end: options.end || currentTimeInSeconds,
    nodeList: Array.isArray(nodeList) ? nodeList : [nodeList],
    dTypeList: options.dTypeList || null,
    objectCodeList: options.objectCodeList || null,
    objectCodeValueFilterStringList:
      options.objectCodeValueFilterStringList || null,
    count: options.count || 2000,
    event: options.event !== undefined ? options.event : null,
  };

  return await axiosInstance.post(
    "/api/TopicData/GetEvetData",
    eventFilterData,
  );
}

export async function getEventDataAll(options = {}) {
  const currentTimeInSeconds = Math.floor(Date.now() / 1000);
  const threeDaysAgoInSeconds = currentTimeInSeconds - 259200;

  const eventFilterData = {
    topic: options.topic || "event",
    start: options.start || threeDaysAgoInSeconds,
    end: options.end || currentTimeInSeconds,
    nodeList: [],
    dTypeList: options.dTypeList || null,
    objectCodeList: options.objectCodeList || null,
    objectCodeValueFilterStringList:
      options.objectCodeValueFilterStringList || null,
    count: options.count || 500,
    event: options.event !== undefined ? options.event : null,
  };

  return await axiosInstance.post(
    "/api/TopicData/GetEvetData",
    eventFilterData,
  );
}

export async function getAndSetEvent(getAndSetEventData) {
  return await axiosInstance.post(
    "/api/TopicData/GetAndSetEvent",
    getAndSetEventData,
  );
}

export async function getAndSetEvent2(getAndSetEventData) {
  return await axiosInstance.post(
    "/api/TopicData/GetAndSetEvent2",
    getAndSetEventData,
  );
}

export async function getAndSetIntEvent(getAndSetEventIntData) {
  return await axiosInstance.post(
    "/api/TopicData/GetAndSetIntEvent",
    getAndSetEventIntData,
  );
}

export async function getPeripheralEnums() {
  return await axiosInstance.get("/api/TopicData/GetPeripheralEnums");
}

export async function getCashlessPaymentDevicesEnums() {
  return await axiosInstance.get(
    "/api/TopicData/GetCasslessPaymentDevicesEnums",
  );
}

export async function getAllEvetData(nodeList, options = {}) {
  const currentTimeInSeconds = Math.floor(Date.now() / 1000);
  const threeDaysAgoInSeconds = currentTimeInSeconds - 259200;

  const eventFilterData = {
    adminList: [],
    topic: options.topic || "event",
    event: options.event || [],
    val: options.val || [],
    start: options.start || threeDaysAgoInSeconds,
    end: options.end || currentTimeInSeconds,
    nodeList: [],
    dTypeList: options.dTypeList || null,
    objectCodeFilterList: options.objectCodeFilterList || null,
    objectCodeValueFilterStringList:
      options.objectCodeValueFilterStringList || null,
    count: options.count || 2000,
    timePeriod: 3,
    gmtZone: 3,
  };

  return await axiosInstance.post(
    "/api/TopicData/GetAllEvetData",
    eventFilterData,
  );
}

export async function getSaleList(nodeList, options = {}) {
  const currentTimeInSeconds = Math.floor(Date.now() / 1000);
  const threeDaysAgoInSeconds = currentTimeInSeconds - 259200;

  const eventFilterData = {
    adminList: [],
    topic: options.topic || "event",
    event: options.event || [1011],
    val: options.val || [],
    start: options.start || threeDaysAgoInSeconds,
    end: options.end || currentTimeInSeconds,
    nodeList: nodeList || [],
    dTypeList: options.dTypeList || [],
    objectCodeFilterList: options.objectCodeFilterList || null,
    objectCodeValueFilterStringList:
      options.objectCodeValueFilterStringList || null,
    count: options.count !== undefined ? options.count : 0,
    timePeriod: options.timePeriod !== undefined ? options.timePeriod : 2,
    gmtZone: options.gmtZone !== undefined ? options.gmtZone : 3,
  };

  return await axiosInstance.post(
    "/api/TopicData/GetSaleList",
    eventFilterData,
  );
}

export async function getSalesGroupByProduct(nodeList, options = {}) {
  const currentTimeInSeconds = Math.floor(Date.now() / 1000);
  const threeDaysAgoInSeconds = currentTimeInSeconds - 259200;

  const eventFilterData = {
    adminList: [],
    topic: options.topic || "event",
    event: options.event || [1011],
    val: options.val || [],
    start: options.start || threeDaysAgoInSeconds,
    end: options.end || currentTimeInSeconds,
    nodeList: nodeList || [],
    dTypeList: options.dTypeList || [],
    objectCodeFilterList: options.objectCodeFilterList || null,
    objectCodeValueFilterStringList:
      options.objectCodeValueFilterStringList || null,
    count: options.count !== undefined ? options.count : 0,
    timePeriod: options.timePeriod !== undefined ? options.timePeriod : 2,
    gmtZone: options.gmtZone !== undefined ? options.gmtZone : 3,
  };

  return await axiosInstance.post(
    "/api/TopicData/GetSalesGroupByProduct",
    eventFilterData,
  );
}

export async function getSalesGroupByDay(nodeList, options = {}) {
  const currentTimeInSeconds = Math.floor(Date.now() / 1000);
  const threeDaysAgoInSeconds = currentTimeInSeconds - 259200;

  const eventFilterData = {
    adminList: [],
    topic: options.topic || "event",
    event: options.event || [1011],
    val: options.val || [],
    start: options.start || threeDaysAgoInSeconds,
    end: options.end || currentTimeInSeconds,
    nodeList: nodeList || [],
    dTypeList: options.dTypeList || [],
    objectCodeFilterList: options.objectCodeFilterList || null,
    objectCodeValueFilterStringList:
      options.objectCodeValueFilterStringList || null,
    count: options.count !== undefined ? options.count : 0,
    timePeriod: options.timePeriod !== undefined ? options.timePeriod : 2,
    gmtZone: options.gmtZone !== undefined ? options.gmtZone : 3,
  };

  return await axiosInstance.post(
    "/api/TopicData/GetSalesGroupByDay",
    eventFilterData,
  );
}

export async function getSalesGroupByNid(nodeList, options = {}) {
  const currentTimeInSeconds = Math.floor(Date.now() / 1000);
  const threeDaysAgoInSeconds = currentTimeInSeconds - 259200;

  const eventFilterData = {
    adminList: [],
    topic: options.topic || "event",
    event: options.event || [1011],
    val: options.val || [],
    start: options.start || threeDaysAgoInSeconds,
    end: options.end || currentTimeInSeconds,
    nodeList: nodeList || [],
    dTypeList: options.dTypeList || [],
    objectCodeFilterList: options.objectCodeFilterList || null,
    objectCodeValueFilterStringList:
      options.objectCodeValueFilterStringList || null,
    count: options.count !== undefined ? options.count : 0,
    timePeriod: options.timePeriod !== undefined ? options.timePeriod : 2,
    gmtZone: options.gmtZone !== undefined ? options.gmtZone : 3,
  };

  return await axiosInstance.post(
    "/api/TopicData/GetSalesGroupByNid",
    eventFilterData,
  );
}

// export async function getSummaryAggregation(
//   aggregation,
//   timePeriod,
//   returnObject,
//   objectCodeFilterList,
//   objectCodeValueFilterStringList,
//   nodeId
// ) {
//   const aggregationData = {
//     aggregation,
//     timePeriod,
//     start: 0,
//     end: Math.floor(Date.now() / 1000),
//     nodeList: [],
//     dTypeList: [1],
//     returnObject: returnObject,
//     objectCodeFilterList: objectCodeFilterList,
//     objectCodeValueFilterStringList: objectCodeValueFilterStringList,
//   };

//   return await axiosInstance.post(
//     `/api/TopicData/GetTopicDataWithAggregationWithNodeId/${nodeId}`,
//     aggregationData
//   );
// }
